import { Pipe, PipeTransform, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
	name: 'woSanitizeHtml',
})
export class SanitizeHtmlPipe implements PipeTransform {
	private readonly sanitizer = inject(DomSanitizer);

	transform(value: string): SafeHtml {
		return this.sanitizer.bypassSecurityTrustHtml(value || '');
	}
}
